var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-rating',{staticClass:"ratingquality",attrs:{"id":"rating-inline","inline":"","value":_vm.ratingStars,"readonly":"","variant":_vm.maxRating ? 'warning' : 'primary',"no-border":""}})}
var staticRenderFns = []

export { render, staticRenderFns }